<template>
  <app-tab :label="$t('header.notificationsTab.modalTabTitle')" id="notification-dialog-updates" class="user-notifications-tab-updates">
    <user-notifications-list v-if="hasUpdates">
      <user-notifications-list-item
        v-for="({ title, description, date }, index) in updates"
        :key="index"
        disabled
        icon="exclamation"
        :title="title + ':'"
        :description="description"
        :date="date" />
    </user-notifications-list>

    <user-notifications-empty-state v-else />
  </app-tab>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import UserNotificationsList from './UserNotificationsList'
  import UserNotificationsListItem from './UserNotificationsListItem'
  import UserNotificationsEmptyState from './UserNotificationsEmptyState'

  export default {
    name: 'UserNotificationsPanelTabUpdates',
    components: {
      UserNotificationsList,
      UserNotificationsListItem,
      UserNotificationsEmptyState
    },
    computed: {
      ...mapState('userNotifications', ['updates']),
      ...mapGetters('auth', ['userId']),
      updateStore () {
        return this.$firebase.collection('updates')
      },
      hasUpdates () {
        return Object.keys(this.updates).length > 0
      }
    },
    async created () {
      Object.keys(this.updates).forEach(id => {
        this.updateStore.doc(this.userId.toString()).set({
          [id]: null
        }, {
          merge: true
        })
      })
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .user-notifications-tab-updates ::v-deep {
    .list-item-icon {
      background-color: #c9d2d4;
      border-radius: 100%;
    }

    .list-item-content {
      display: block;
    }

    .list-item-title {
      color: $color-red-orange;
    }

    .list-item-title,
    .list-item-description,
    .list-item-date {
      font-size: 14px;
      line-height: 1.4em;
    }
  }
</style>
